import {DateRange} from "../reusables/APXDateRangePicker.jsx";
import type {BaseDates, BasePayers} from "./FirebaseSchemaModels.js";
import {PayerModel, TripModel} from "./FirebaseSchemaModels.js";


export function generateStartEndDateTexts(trip: TripModel): string {
	  const startDate = trip.getStartDate();
	  const endDate = trip.getEndDate();
	  if (startDate === null || endDate === null) return "Dates not set";
	  return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
}


export function generateTripDates(dateRange: DateRange): BaseDates {
	  const tripDates: BaseDates = {};
	  if (dateRange.from.trim() === "" || dateRange.to.trim() === "") return tripDates;
	  let currentDate: Date = new Date(new Date(dateRange.from).setHours(0, 0, 0, 0));
	  const endDate: Date = new Date(new Date(dateRange.to).setHours(0, 0, 0, 0));
	  while (currentDate <= endDate) {
			 tripDates[currentDate.getTime()] = currentDate.toLocaleDateString();
			 currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
	  }
	  return tripDates;
}


export function areDateRangesEqual(dateRange1: DateRange, dateRange2: DateRange): boolean {
	  return dateRange1.from === dateRange2.from && dateRange1.to === dateRange2.to;
}


export function convertAnchoredDateLocaleTextToMillis(dateLocaleText: string | null): number | null {
	  if (/*FALSY->*/ !!!dateLocaleText) return null;
	  const parts = dateLocaleText.split("/");
	  const dateIsoText = `${parts[1]}/${parts[0]}/${parts[2]}`;
	  return new Date(dateIsoText).getTime();
}


export function getPayerByName(payers: BasePayers, name: string): PayerModel {
	  if (/*FALSY->*/ !!!payers || /*FALSY->*/ !!!name) throw new Error("Payers or name is empty");
	  return Object.values(payers).find(payer => payer.name === name);
}


export function paid(payer: PayerModel, amount: number): void {
	  if (payer !== null) {
			 payer.setPaid(payer.paid + amount);
	  }
}


export function due(payers: BasePayers, name: string, totalPersons: number, amount: number): void {
	  if (payers !== null) {
			 for (let payer of Object.values(payers)) {
					if (payer !== null) {
						  const payingFor = payer.payingFor;
						  if (name === payer.name) {
								 payer.setDue(payer.due - (amount / totalPersons * (totalPersons - payingFor)));
						  } else {
								 payer.setDue(payer.due + (amount / totalPersons * payingFor));
						  }
					}
			 }
	  }
}


export function reimbursed(byPayer: PayerModel, toPayer: PayerModel, amount: number): void {
	  if (byPayer !== null && toPayer !== null) {
			 byPayer.setDue(byPayer.due - amount);
			 toPayer.setDue(toPayer.due + amount);
	  }
}


export function formatCurrency(amount: number): string {
	  return amount.toLocaleString("en-IN", {style: "currency", currency: "INR"});
}